var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.284668,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#B4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.28467C14.9185 2.28467 18.5 5.86586 18.5 10.2847C18.5 14.7035 14.9185 18.2847 10.5 18.2847C8.6193 18.2847 6.83778 17.6332 5.41618 16.4617C4.62814 15.8128 3.96819 15.0164 3.4783 14.1206C2.83974 12.9528 2.5 11.6425 2.5 10.2847C2.5 5.86586 6.08152 2.28467 10.5 2.28467ZM10.5 3.28467C6.63379 3.28467 3.5 6.41817 3.5 10.2847C3.5 11.4736 3.79701 12.6191 4.35569 13.6408C4.78424 14.4244 5.36206 15.1217 6.05198 15.6898C7.29626 16.7152 8.8535 17.2847 10.5 17.2847C14.3662 17.2847 17.5 14.1512 17.5 10.2847C17.5 6.41817 14.3662 3.28467 10.5 3.28467ZM10.5 5.78467C10.7761 5.78467 11 6.00853 11 6.28467V10.2516L13.2572 11.6059C13.494 11.748 13.5708 12.0551 13.4287 12.2919C13.2867 12.5287 12.9795 12.6055 12.7428 12.4634L10.2428 10.9634C10.0921 10.8731 10 10.7103 10 10.5347V6.28467C10 6.00853 10.2239 5.78467 10.5 5.78467Z",
    fill: "#323C32"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.5e9e2e3700cbd8afcb1db2f453091099.svg";
export { ForwardRef as ReactComponent };